import { Component, ViewEncapsulation, Input, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { InventoryReference } from '../../../shared/models/InventoryReference';
import { SaveMode } from '../../../shared/enums/SaveMode';
import { StockReplenishmentBus } from '../../../shared/models/StockReplenishmentBus';
import * as _ from 'lodash';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'stock-replenishment-detail',
    templateUrl: './stock-replenishment-detail.component.html',
    styleUrls: ['./stock-replenishment-detail.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class StockReplenishmentDetailComponent extends BaseGridEditLineComponent<StockReplenishmentBus, null, InventoryService> {

    @Input() inventoryReferenceData: InventoryReference

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InventoryService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.className = "StockReplenishmentBus";
        this.appCode = "StockReplenishmentBus";
        this.saveMode = SaveMode.all;
        this.disableCpSearchDialog();
    }

    override createForm() {
        this.editForm = new FormGroup({
            'id': new FormControl(null, Validators.required),
            'name': new FormControl(null),
            'onStockReplenishment': new FormControl(null),

        });

    }
    override checkBoxChanged(e: any, dataItem, rowIndex: any, column, columnIndex) {
        var ri = this.gridData.findIndex(a => a.id == dataItem.id)
        if (this.gridData[ri].onStockReplenishment == true) { this.gridData[ri].onStockReplenishment = false; }
        else { this.gridData[ri].onStockReplenishment = true; }
        this.gridData[ri].isUpdated = true;

    }
    override setForm() {
        this.editForm.patchValue({
            id: this.selectedData.id,
            name: this.selectedData.name,
            onStockReplenishment: this.selectedData.onStockReplenishment,
        });
    }
}
